export const z1 = '1'
export const z2 = '2'
export const z3 = '3'
export const z4 = '4'
export const z5 = '5'
export const zMax = '9999'
